import { TwConfirmDialog } from "../../components/tailwind";

export default function ErrorDialog({ open, text, onClose, btnCloseText = "Close", isCloseBtn = true, }) {
  return (
    <TwConfirmDialog
      dialogOpen={open}
      isCloseBtn={isCloseBtn}
      btnCloseText={btnCloseText}
      isConfirmBtn={false}
      dialogType="error"
      dialogTitle="Error"
      dialogMessage={text}
      onClose={onClose}
    />
  )
}
